import { useContext, useState } from "react";

import styled from "styled-components";
import Button from "../components/CustomButton";
import ErrorMessage from "../components/ErrorMessage";
import HeaderText from "../components/HeaderText";
import CustomInput from "../components/inputs/CustomInput";
import InputContainer from "../components/inputs/InputContainer";
import Context from "../contexts/data";

const TextContainer = styled.div`
    p {
        font-family: "Inter";
        font-style: normal;
        font-weight: 400;
        font-size: 1rem;
        line-height: 1.5rem;
        margin-bottom: 1rem;
    }

    span {
        font-family: "Inter";
        font-style: normal;
        font-weight: 600;
        font-size: 1rem;
        line-height: 1.5rem;
        text-align: center;
        text-decoration: none;
        color: #0da6f2;
        cursor: pointer;
    }

    @media (max-width: 32.1875rem) {
        p {
            font-size: 0.875rem;
            line-height: 0.75rem;
        }

        span {
            font-size: 0.875rem;
            line-height: 0.75rem;
        }
    }
`;

export default function Verification() {
    const {
        checkTwilioCode,
        errorMessage,
        handleUpdateFormValue,
        handleSubmit,
        navigate
    } = useContext(Context);

    const [code, setCode] = useState("");
    const [totalTries, setTotalTries] = useState(0);

    const handleChange = (e) => {
        const { value } = e.target;
        if (value.length <= 6) {
            setCode(value);
        }
    };

    const handleNextStep = async () => {
        setTotalTries(totalTries => totalTries + 1);

        if (!code && totalTries < 2) {
            handleUpdateFormValue("errorMessage", "Please enter your validation code.");
            return;
        }

        if (code.length < 6 && totalTries < 2) {
            handleUpdateFormValue("errorMessage", "Your validation code is wrong.");
            return;
        }

        const isValidated = await checkTwilioWrapper(code);

        if (!isValidated && totalTries < 2) {
            handleUpdateFormValue("errorMessage", "Your validation code is wrong.");
            return;
        } else {
            handleSubmit(isValidated);
            navigate("result", "TFA");
        }
    };

    const checkTwilioWrapper = async (userCode) => {
        const data = await checkTwilioCode(userCode);

        if (data.status === "approved") {
            return true;
        }

        return false;
    };

    return (
        <>
            <HeaderText bigger_text={"Enter your verification code."} />
            <InputContainer>
                <CustomInput
                    name="TFA"
                    fieldClass="phoneNumber"
                    errorMessage={errorMessage}
                    value={code}
                    onChange={handleChange}
                    placeholder={"Enter your code."}
                />
            </InputContainer>
            <TextContainer>
                <p>
                    Didn&apos;t receive a code?{" "}
                    <span
                        onClick={() => {
                            navigate("/phone-number");
                        }}
                    >
                        Use a different number.
                    </span>
                </p>
            </TextContainer>
            <ErrorMessage />
            <Button text={"Submit"} onClick={handleNextStep} hideBBB={true} />
        </>
    );
}